import React, { useState } from 'react'
import L1 from './Components/L1'
import L2 from './Components/L2'
import Popular from './Components/Popular'
import L5 from './Components/L5'
import L4 from './Components/L4'
import Footer from '../../Components/Footer'
import Preview from './Components/Preview'
import NewlyAdded from './Components/NewlyAdded'
import ByInstitutions from './Components/ByInstitutions'
import SideBar from '../../Components/Sideabar'

export default function Landing() {
  const [selectedCourse, setSelectedCourse] = useState()
  return (
    // <div className='w-full flex bg-[#f2f2f2] h-screen overflow-hidden'>
    //   <SideBar />
      <div className='flex-col flex-1 overflow-auto h-full overflow-x-hidden'>
        <L1 />
        <Popular setSelectedCourse={setSelectedCourse} />
        {/* <NewlyAdded setSelectedCourse={setSelectedCourse} /> */}
        {/* <ByInstitutions setSelectedCourse={setSelectedCourse} /> */}
        <L4 />
        <L5 />
         <L2 />
        {selectedCourse && <Preview setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse} /> }
        <Footer />
      </div>
    // </div>
  )
}